<template>
  <div class="change-password">
    <div class="page-header">
      <h1>{{ $t('common.changePassword') }}</h1>
    </div>
    <Card shadow>
      <Form ref="passwordForm" :model="passwordForm" :rules="rules">
        <Row>
          <i-col span="14">
            <FormItem :label="$t('common.oldPassword')" prop="oldPassword">
              <i-input v-model="passwordForm.oldPassword" size="large" type="password"></i-input>
            </FormItem>
          </i-col>
          <i-col span="14">
            <FormItem :label="$t('common.newPassword')" prop="newPassword">
              <i-input v-model="passwordForm.newPassword" type="password" size="large"></i-input>
            </FormItem>
          </i-col>
          <i-col span="14">
            <FormItem :label="$t('common.confirmPassword')" type="password" prop="confirmPassword">
              <i-input v-model="passwordForm.confirmPassword" type="password" size="large"></i-input>
            </FormItem>
          </i-col>
          <i-col span="14" class="oper-col">
            <Button type="primary" @click="submitPassword">{{ $t('common.submit') }}</Button>
          </i-col>
        </Row>
      </Form>
    </Card>
  </div>
</template>

<script>
import auth, { updateUser } from '@/api/auth'

export default {
  name: 'ChangePassword',

  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('common.pleaseEnterYourPasswordAgain')))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error(this.$t('common.confirmNotMatch')))
      } else {
        callback()
      }
    }
    return {
      passwordForm: {},
      rules: {
        oldPassword: [{ required: true, message: this.$t('common.fillContent') }],
        newPassword: [{ required: true, message: this.$t('common.fillContent') }],
        confirmPassword: [
          { required: true, message: this.$t('common.pleaseEnterYourPasswordAgain') },
          { validator: validatePass, trigger: 'blur' },
        ],
      },
    }
  },

  computed: {
    user() {
      return this.$store.state.user
    },
  },

  methods: {
    submitPassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (!valid) {
          return
        }
        const { username, userId, roleId } = this.user
        auth({
          username,
          password: this.passwordForm.oldPassword,
        })
          .then(() => {
            updateUser(userId, {
              username,
              password: this.passwordForm.newPassword,
              roleId,
            })
              .then(() => {
                this.$Message.success(this.$t('common.changePasswordSuccess'))
                setTimeout(() => {
                  this.$router.push({ path: '/login' })
                }, 500)
              })
              .catch(() => {})
          })
          .catch(() => {})
      })
    },
  },
}
</script>

<style lang="scss">
.change-password {
  .oper-col {
    margin-bottom: 10px;
  }
}
</style>
